module.exports = __webpack_public_path__ + "static/media/date_icon_error.09659c80.svg";